const filterProducts = (store, products) => {
  const prices = store.getters.getPrices;

  const pricesMap = new Map(prices.map((price) => [price.sku, price.price]));

  return products
    ? Array.isArray(products)
      ? products.filter(
          (product) =>
            pricesMap.has(product.sku || product.sage_id) &&
            store.getters.getActualPrice(product.sku || product.sage_id) > 0
        ) ?? []
      : pricesMap.has(products.sku || products.sage_id) &&
        store.getters.getActualPrice(products.sku || products.sage_id) > 0
      ? products
      : []
    : [];
};

export { filterProducts };
